module.exports = ".dialog-actions {\n  margin: 10px;\n  text-align: right;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/confirm-dialog/confirm-dialog.component.css
// module id = ./src/app/shared/confirm-dialog/confirm-dialog.component.css
// module chunks = main